import { render, staticRenderFns } from "./kapor-form-confirmation.vue?vue&type=template&id=d81873c4&scoped=true&lang=pug"
import script from "./kapor-form-confirmation.vue?vue&type=script&lang=js"
export * from "./kapor-form-confirmation.vue?vue&type=script&lang=js"
import style0 from "./kapor-form-confirmation.vue?vue&type=style&index=0&id=d81873c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d81873c4",
  null
  
)

export default component.exports